const getters = {
  decodeInfo: state => state.user.decodeInfo,
  merchantInfo: state => state.user.merchantInfo,
  isOem: state => state.user.isOem,
  merchantSuccess: state => state.user.merchantSuccess,
  inductApplet: state => state.user.inductApplet
}
export default getters
